export const validateEmail = email => {
  const regexToValidateEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return (
    typeof email === 'string' &&
    regexToValidateEmail.test(email.toLocaleLowerCase())
  );
};

export const estadosBr = [
  {
    value: 'TO',
    label: 'TO'
  },
  {
    value: 'BA',
    label: 'BA'
  },
  {
    value: 'SE',
    label: 'SE'
  },
  {
    value: 'PE',
    label: 'PE'
  },
  {
    value: 'AL',
    label: 'AL'
  },
  {
    value: 'RN',
    label: 'RN'
  },
  {
    value: 'CE',
    label: 'CE'
  },
  {
    value: 'PI',
    label: 'PI'
  },
  {
    value: 'MA',
    label: 'MA'
  },
  {
    value: 'AP',
    label: 'AP'
  },
  {
    value: 'PA',
    label: 'PA'
  },
  {
    value: 'RR',
    label: 'RR'
  },
  {
    value: 'AM',
    label: 'AM'
  },
  {
    value: 'AC',
    label: 'AC'
  },
  {
    value: 'RO',
    label: 'RO'
  },
  {
    value: 'MT',
    label: 'MT'
  },
  {
    value: 'MS',
    label: 'MS'
  },
  {
    value: 'GO',
    label: 'GO'
  },
  {
    value: 'PR',
    label: 'PR'
  },
  {
    value: 'SC',
    label: 'SC'
  },
  {
    value: 'RS',
    label: 'RS'
  },
  {
    value: 'SP',
    label: 'SP'
  },
  {
    value: 'MG',
    label: 'MG'
  },
  {
    value: 'RJ',
    label: 'RJ'
  },
  {
    value: 'ES',
    label: 'ES'
  },
  {
    value: 'DF',
    label: 'DF'
  },
  {
    value: 'PB',
    label: 'PB'
  }
];
